<!-- A persistent live region: changes (a new count, a cleared message) are announced, not only the first. -->
<div aria-live="polite" class="app-message-field">
  @if (message) {
    <p [class]="severity" class="alert" role="alert">{{ message }}</p>
  } @else {
    <p>&nbsp;</p>
  }
</div>
